export const RSA_ADDON_ID = '01036';

export enum UserType {
  INDIVIDUAL = 'individual',
  COMPANY = 'company',
}
